var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdThermal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C3E17E",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M10.949 4.005a.623.623 0 0 0-.707.561C9.79 9.736 6 10.216 6 14.947 6 17.366 8.034 20 12 20s6-3.114 6-5.895c0-3.463-1.168-5.333-1.93-6.424-.244-.348-.788-.32-.986.056-.222.421-.543.842-.941.842-.697 0-.839-2.79-2.873-4.434a.642.642 0 0 0-.321-.14zm1.933 8.343s.883 1.59.883 3.975c0 .91-.755 1.59-1.765 1.59-1.01 0-1.765-.766-1.765-1.59 0-1.182.883-2.385.883-2.385s.357.795.882.795c.815 0 .882-2.385.882-2.385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdThermal);
export default __webpack_public_path__ + "static/media/icon-pd-thermal.321c6e95e4c32222c975b34af1c6fa0b.svg";
export { ForwardRef as ReactComponent };